// NewsItem.tsx — Single ICP News entry (editorial register card).
//
// Visual hierarchy per DESIGN.md §7 news-item spec:
//   source tag → posted timestamp → headline → excerpt → open-original link
//
// Source tags use single visual register (gold on gold-stroke) — no per-source
// color. Origin is conveyed via text, not color. (Brand Bible Ch 9)
//
// Lore-approved action label: "Open original" (NW-62).

import React from 'react';
import type { NewsItem as NewsItemType } from '../hooks/useAdminNews';

interface NewsItemProps {
  item: NewsItemType;
}

export default function NewsItem({ item }: NewsItemProps): React.ReactElement {
  return (
    <li className="news-item">
      <div className="news-item-row">
        <span className="news-source">{item.source}</span>
        <span className="news-posted">
          {item.postedRelative} · {item.postedDate}
        </span>
      </div>
      <h3 className="news-headline">{item.headline}</h3>
      <p className="news-excerpt">{item.excerpt}</p>
      {item.url !== '#' ? (
        <a
          className="news-action"
          href={item.url}
          target="_blank"
          rel="noopener noreferrer"
        >
          Open original
        </a>
      ) : (
        <span className="news-action" aria-hidden="true">Open original</span>
      )}
    </li>
  );
}
